import {
    ContentLabel,
    GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
    GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL,
    REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
    REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL,
    UNKNOWN_CONTENT_LABEL,
} from '@/types/reel.type';

export function getContentLabel({
    isAiAudio,
    isAiVideo,
}: {
    isAiAudio: boolean;
    isAiVideo: boolean;
}): ContentLabel {
    if (!isAiAudio && !isAiVideo) {
        return REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL;
    }

    if (isAiAudio && isAiVideo) {
        return GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL;
    }

    if (isAiVideo) {
        return GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL;
    }

    if (isAiAudio) {
        return REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL;
    }

    return UNKNOWN_CONTENT_LABEL;
}
